import {
    SEND_REQUEST_REQUEST,
    SEND_REQUEST_SUCCESS,
    SEND_REQUEST_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const SendRequestAction = (data) => {

    return function (dispatch) {
      dispatch({
        type: SEND_REQUEST_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/send_interview_request`,
        method: "PUT",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
  
      axios(OPTION)
        .then((res) => {
          dispatch(updateDashboardContentPre(res.data));
        })
        .catch((error) => {
          toast.error(error.response.data.status.message);
          dispatch({
            type: SEND_REQUEST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
         
        });
    };
  };

  export const updateDashboardContentPre = (data) => {
    toast.success("Send Request Successfully!");
    return {
      type: SEND_REQUEST_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };